import MarkdownIt from 'markdown-it'
import { truncate } from 'libraries/lodash'

const md = new MarkdownIt({ linkify: true, breaks: true })

const defaultLinkOpen = md.renderer.rules.link_open ||
  ((tokens, idx, options, env, self) => self.renderToken(tokens, idx, options))

// External links open in a new tab
// http(s) links are targeted so in-page anchors (#section) and mailto: links still behave normally.
md.renderer.rules.link_open = (tokens, idx, options, env, self) => {
  const token = tokens[idx]
  if (/^https?:/i.test(token.attrGet('href'))) {
    token.attrSet('target', '_blank')
    token.attrSet('rel', 'noopener noreferrer')
  }
  return defaultLinkOpen(tokens, idx, options, env, self)
}

export const renderMarkdown = text => md.render(text)

// Cutting mid-line can sever a list marker (e.g. "2. Second" -> "2"), which
// markdown-it then treats as plain text continuing the previous list item -
// collapsing the whole list down to a single "1." Truncating on whole lines
// keeps every list marker intact.
export const truncateMarkdown = (text, length) => {
  if (text.length <= length) {
    return text
  }

  const lines = text.split('\n')
  let result = ''

  for (const line of lines) {
    const next = result ? `${result}\n${line}` : line
    if (next.length > length) {
      break
    }
    result = next
  }

  return result || truncate(text, { length })
}
